// import BaseTheme from 'quill/themes/base';
import extend from 'extend';
let BaseTheme = Quill.import('core/theme');

import Quill from "quill";

import KeyboardBindings from "./KeyboardBindings";


class Theme extends BaseTheme {

    constructor(quill, options) {
        super(quill, options);
        this.addModule("embed/focus");
    }
}

export default Theme;
